import axios from "axios";

const CHANNEL_PARTNER_AUTH_STORAGE_KEY = "channel-partner-login-user";

const getStoredChannelPartnerUser = () => {
  try {
    const storedUser = localStorage.getItem(CHANNEL_PARTNER_AUTH_STORAGE_KEY);
    return storedUser ? JSON.parse(storedUser) : null;
  } catch {
    localStorage.removeItem(CHANNEL_PARTNER_AUTH_STORAGE_KEY);
    return null;
  }
};

const channelPartnerHttpCommon = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

channelPartnerHttpCommon.interceptors.request.use(
  (config) => {
    const token = config.skipAuth ? null : getStoredChannelPartnerUser()?.token;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

channelPartnerHttpCommon.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(CHANNEL_PARTNER_AUTH_STORAGE_KEY);
      window.location.href = "/channel-partner-portal/login";
    }
    return Promise.reject(error);
  },
);

export default channelPartnerHttpCommon;
